<!-- eslint-disable max-lines -->
/*
 * File: 客户模块-客户管理-详情-一页纸
 */
<template>
    <div class="paper-dialog">
        <el-dialog
            :visible="visible"
            width="90vw"
            top="4vh"
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="handleClose"
        >
            <template slot="title">
                <span style="vertical-align: middle;margin-right: 8px;">{{ detailData.pageName }}</span>
                <img src="@/assets/images/icon-edit.png" alt="" @click="handleEditTitle" style="width: 20px;height: 20px;vertical-align: middle;cursor: pointer;" />
            </template>
            <h3>{{ detailData.title }}</h3>

            <!-- 一、公司介绍 -->
            <Segment
                ref="segmentPart1Ref"
                :detailData="part1"
                :oldContent="currentPageOriginPart.part1"
                :initContent="originalData.part1"
                :streamDescription="part1StreamDescription"
                :streamContent="diffHtmlPart.part1"
                :loading="part1Loading"
                :disabled="saveStatus"
                @updateData="(data) => handleChange(data, 'part1')"
                @updateContent="(data) => handleChangeContent(data, 'part1')"
                @regenerate="(data) => getStreamData(data, 'part1','change')"
            />
            <!-- 二、渠道模式及竞对分析 -->
            <Segment
                ref="segmentPart2Ref"
                :detailData="part2"
                :oldContent="currentPageOriginPart.part2"
                :initContent="originalData.part2"
                :streamDescription="part2StreamDescription"
                :streamContent="diffHtmlPart.part2"
                :loading="part2Loading"
                :disabled="saveStatus"
                @updateData="(data) => handleChange(data, 'part2')"
                @updateContent="(data) => handleChangeContent(data, 'part2')"
                @regenerate="(data) => getStreamData(data, 'part2','change')"
            />
            <!-- 三、合作情况 -->
            <Segment ref="segmentPart3Ref" :detailData="part3" :disabled="saveStatus" />
            <!-- 四、合作探讨 -->
            <Segment
                ref="segmentPart4Ref"
                :detailData="part4"
                :initContent="originalData.part4"
                :oldContent="currentPageOriginPart.part4"
                :streamDescription="part4StreamDescription"
                :streamContent="diffHtmlPart.part4"
                :loading="part4Loading"
                :disabled="saveStatus"
                @updateData="(data) => handleChange(data, 'part4')"
                @updateContent="(data) => handleChangeContent(data, 'part4')"
                @regenerate="(data) => getStreamData(data, 'part4','change')"
            />
            <!-- 五、组织架构 -->
            <Segment
                ref="segmentPart5Ref"
                :detailData="part5"
                :oldContent="currentPageOriginPart.part5"
                :initContent="originalData.part5"
                :streamDescription="part5StreamDescription"
                :streamContent="diffHtmlPart.part5"
                :loading="part5Loading"
                :disabled="saveStatus"
                @updateData="(data) => handleChange(data, 'part5')"
                @updateContent="(data) => handleChangeContent(data, 'part5')"
                @regenerate="(data) => getStreamData(data, 'part5','change')"
            />

            <div v-if="detailData.versionCode">
                <span style="margin-right: 15px;">生成时间：{{ utils.formatDateTime(detailData.createTime) }}</span>
                <span>版本号：{{ detailData.versionCode }}</span>
            </div>
            <span slot="footer">
                <el-button size="small" @click="handlePreview" :disabled="!detailData.docUrl && !detailData.pdfUrl">预览</el-button>
                <el-button size="small" @click="handleSave('draft')" :disabled="draftStatus" :loading="loading">存草稿</el-button>
                <el-button size="small" @click="handleSave('saveAs')" :disabled="saveStatus" :loading="loading">另存为</el-button>
                <el-button size="small" type="primary" @click="handleSave('save')" :disabled="saveStatus" :loading="loading">保存</el-button>
            </span>
        </el-dialog>

        <!-- 一页纸附件命名 -->
        <FileNameDialog ref="fileNameDialogRef" @confirm="handleConfirm" />
    </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import utils from '@/components/utils/common.js';
import { filePreview } from '@/utils/filePreview.js';
import store from '@/store/index';
import _ from 'lodash';
import Segment from './component/segment.vue';
import FileNameDialog from './component/fileNameDialog.vue';
import {
    getCustomeOnePageDetail,
    streamCustomeOnePage,
    getCustomeOnePageIncome,
    getCustomeOnePageScaleComparison,
    getCustomeOnePageLatestVersion,
    saveCustomeOnePage
} from '@/modules/mdm/api/customer/customerManage.js';
import { htmlDiffMultiple } from './htmlDiff.js';
import { markdownFormat, formatDatasource } from './config';
const md = markdownFormat();

export default {
    components: { Segment, FileNameDialog },
    props: {
        managerRole: {
            type: Boolean,
            return: false
        },
        customerFormDetail: {
            type: Object,
            return: () => {}
        }
    },
    /* eslint-disable max-lines-per-function */
    /* eslint-disable max-len */
    setup(props, setupContext) {
        const emit = setupContext.emit;
        const visible = ref(false);
        const detailData = ref({});
        const { userCode } = store.getters.user;
        const saveStatus = computed(() => {
            const { pageStatus, createUserCode, customerOnePageVersion } = detailData.value;
            if (['2'].includes(pageStatus?.toString())) { // 废弃不可保存
                return true;
            }
            if (customerOnePageVersion?.docAnalysed === '0') { // 上传的文档解析失败不可保存：空-不是上传，0-上传但是解析失败，1-上传并解析成功
                return true;
            }
            // !(管理员 || 创建人===当前用户) 可以编辑
            return !(props.managerRole || (createUserCode === userCode));
        });
        const draftStatus = computed(() => {
            const { pageStatus, createUserCode } = detailData.value;
            if (!['0'].includes(pageStatus?.toString())) { // 非草稿状态不可点击
                return true;
            }
            // !(管理员 || 创建人===当前用户) 可以编辑
            return !(props.managerRole || (createUserCode === userCode));
        });
        const part1 = ref({
            title: '一、公司介绍',
            type: 'part1',
            module_content: 0,
            ai: {
                activeNames: ['1'],
                runtime: null,
                datasource: []
            }
        });
        const part2 = ref({
            title: '二、渠道模式及竞对分析',
            type: 'part2',
            module_content: 1,
            imgUrl: '',
            fileList: [],
            ai: {
                activeNames: ['1'],
                runtime: null,
                datasource: []
            }
        });
        const part3 = ref({
            title: '三、合作情况',
            type: 'part3',
            fileContent: '',
            tableData1: [],
            tableData2: [],
            tableSummary: '',
            ai: {}
        });
        const part4 = ref({
            title: '四、合作探讨',
            type: 'part4',
            module_content: 2,
            ai: {
                activeNames: ['1'],
                runtime: null,
                datasource: []
            }
        });
        const part5 = ref({
            title: '五、组织架构',
            type: 'part5',
            module_content: 3,
            ai: {
                activeNames: ['1'],
                runtime: null,
                datasource: []
            }
        });
        const initOriginalDataPart = {
            part1: null,
            part2: null,
            part4: null,
            part5: null
        };
        const originalDataPart = ref(_.cloneDeep(initOriginalDataPart));
        // eslint-disable-next-line complexity
        const diffHtmlPart = computed(() => {
            // 当草稿时,数据没有入库, 不做对比,当前内容没有变化时,不做对比
            const { part1: opart1, part2: opart2, part4: opart4, part5: opart5 } = originalDataPart.value;
            const isFormat = {
                part1: opart1 === null || (updatePart.value.part1 ? opart1 !== part1StreamContent.value : false),
                part2: opart2 === null || (updatePart.value.part2 ? opart2 !== part2StreamContent.value : false),
                part4: opart4 === null || (updatePart.value.part4 ? opart4 !== part4StreamContent.value : false),
                part5: opart5 === null || (updatePart.value.part5 ? opart5 !== part5StreamContent.value : false)
            };
            return {
                part1: isFormat.part1 ? part1StreamContent.value : htmlDiffMultiple(opart1, part1StreamContent.value),
                part2: isFormat.part2 ? part2StreamContent.value : htmlDiffMultiple(opart2, part2StreamContent.value),
                part4: isFormat.part4 ? part4StreamContent.value : htmlDiffMultiple(opart4, part4StreamContent.value),
                part5: isFormat.part5 ? part5StreamContent.value : htmlDiffMultiple(opart5, part5StreamContent.value)
            };
        });
        const part1StreamDescription = ref('');
        const part1StreamContent = ref('');
        const part1Loading = ref(false);
        const part1AbortFetch = ref(null); // 中止请求
        const part2StreamDescription = ref('');
        const part2StreamContent = ref('');
        const part2Loading = ref(false);
        const part2AbortFetch = ref(null); // 中止请求
        const part4StreamDescription = ref('');
        const part4StreamContent = ref('');
        const part4Loading = ref(false);
        const part4AbortFetch = ref(null); // 中止请求
        const part5StreamDescription = ref('');
        const part5StreamContent = ref('');
        const part5Loading = ref(false);
        const part5AbortFetch = ref(null); // 中止请求
        const loading = computed(() => part1Loading.value || part2Loading.value || part4Loading.value || part5Loading.value);
        const currentPageOriginPart = ref({
            part1: '',
            part2: '',
            part4: '',
            part5: ''
        });

        // 打开弹窗
        const show = async (params, type) => {
            visible.value = true;
            part1Loading.value = false;
            part2Loading.value = false;
            part4Loading.value = false;
            part5Loading.value = false;
            originalDataPart.value = _.cloneDeep(initOriginalDataPart);
            detailData.value = { ...params, pageStatus: '0' }; // 默认草稿状态
            await getDetailData(params.id);

            // 新建一页纸，请求AI
            if (type) {
                getStreamData({ mode: 'generate', module_content: 0 }, 'part1'); // 公司介绍
                getStreamData({ mode: 'generate', module_content: 1 }, 'part2'); // 渠道模式及竞对分析
                getStreamData({ mode: 'generate', module_content: 2 }, 'part4'); // 合作探讨
                getStreamData({ mode: 'generate', module_content: 3 }, 'part5'); // 组织架构
            }
        };
        // 获取详情
        const originalData = ref({});
        const getDetailData = async (id) => {
            const { data } = await getCustomeOnePageDetail({ id });
            detailData.value = {
                ...data,
                customerName: detailData.value.customerName,
                customerCode: detailData.value.customerCode,
                customerGroupName: detailData.value.customerGroupName,
                title: detailData.value.customerGroupName + '合作介绍',
                total: detailData.value.total
            };
            originalData.value = _.cloneDeep(detailData.value);
            originalData.value.part1 = data.customerOnePageVersion.part1;
            originalData.value.part2 = data.customerOnePageVersion.part2;
            originalData.value.part4 = data.customerOnePageVersion.part4;
            originalData.value.part5 = data.customerOnePageVersion.part5;
            part1StreamContent.value = data.customerOnePageVersion.part1;
            part2StreamContent.value = data.customerOnePageVersion.part2;
            part2.value.imgUrl = detailData.value.imgUrl;
            part2.value.fileList = detailData.value.imgUrl ? [{ url: detailData.value.imgUrl }] : [];
            part4StreamContent.value = data.customerOnePageVersion.part4;
            part5StreamContent.value = data.customerOnePageVersion.part5;
            currentPageOriginPart.value = _.cloneDeep(_.pick(originalData.value, ['part1', 'part2', 'part4', 'part5']));
            part3.value.fileContent = data.customerOnePageVersion.docAnalysed ? data.customerOnePageVersion.part3 : '';

            // 获取上一个版本的数据
            await getCustomeOnePageLatestVersion({ customerGroupCode: detailData.value.customerGroupCode }).then(res => {
                if (+res.code === 0) {
                    // 非成稿状态，取上一个版本图片
                    if (detailData.value.pageStatus !== '1') {
                        part2.value.imgUrl = res.data?.imgUrl;
                        part2.value.fileList = res.data?.imgUrl ? [{ url: res.data.imgUrl }] : [];
                    }
                    if (detailData.value.docUrl || detailData.value.pdfUrl) {
                        originalDataPart.value = _.cloneDeep(_.pick(res.data?.customerOnePageVersion, ['part1', 'part2', 'part4', 'part5']));
                    }
                }
            });
            updatePart1.value = false;
            updatePart2.value = false;
            updatePart4.value = false;
            updatePart5.value = false;
            updatePart.value = _.cloneDeep(initUpdatePart);
            // 获取合作情况
            !data.customerOnePageVersion.docAnalysed && getPart3Data();
        };
        // 获取合作情况
        const getPart3Data = () => {
            getCustomeOnePageScaleComparison({ customerGroupCode: detailData.value.customerGroupCode }).then(res => {
                if (+res.code === 0) {
                    part3.value.tableData1 = res.data?.map((v) => ({
                        ...v,
                        customerTotalScale: v.customerTotalScale?.toFixed(2),
                        cooperationScale: v.cooperationScale?.toFixed(2),
                        pendingCooperationScale: v.pendingCooperationScale?.toFixed(2)
                    })) || [];
                }
            });
            getCustomeOnePageIncome({ customerGroupCode: detailData.value.customerGroupCode }).then(res => {
                if (+res.code === 0) {
                    part3.value.tableData2 = res.data?.incomeProfitVoList?.map((v) => ({
                        ...v,
                        totalIncomeBefore2Y: v.totalIncomeBefore2Y ? v.totalIncomeBefore2Y.toFixed(2) : '/',
                        totalProfitBefore2Y: v.totalProfitBefore2Y ? v.totalProfitBefore2Y.toFixed(2) : '/',
                        profitRateBefore2Y: v.profitRateBefore2Y ? (v.profitRateBefore2Y.toFixed(2)) + '%' : '/',
                        totalIncomeBefore1Y: v.totalIncomeBefore1Y ? v.totalIncomeBefore1Y.toFixed(2) : '/',
                        totalProfitBefore1Y: v.totalProfitBefore1Y ? v.totalProfitBefore1Y.toFixed(2) : '/',
                        profitRateBefore1Y: v.profitRateBefore1Y ? (v.profitRateBefore1Y.toFixed(2)) + '%' : '/',
                        totalIncomeBefore0Y: v.totalIncomeBefore0Y ? v.totalIncomeBefore0Y.toFixed(2) : '/',
                        totalProfitBefore0Y: v.totalProfitBefore0Y ? v.totalProfitBefore0Y.toFixed(2) : '/',
                        profitRateBefore0Y: v.profitRateBefore0Y ? (v.profitRateBefore0Y.toFixed(2)) + '%' : '/'
                    })) || [];

                    part3.value.tableSummary = '';
                    if (res.data?.calcResult) {
                        const { companyNum, totalIncome, sumProfitRate, businessCategoryStatistics } = res.data.calcResult;
                        const year = utils.formatDateTime(new Date(), 'YYYY');
                        const month = utils.formatDateTime(new Date(), 'MM');
                        let str = '';
                        Object.keys(businessCategoryStatistics).forEach((key) => {
                            str += `${businessCategoryStatistics[key]}个${key}，`;
                        });
                        part3.value.tableSummary = `${year}年截至${month - 1}月，合作了${companyNum}个分公司。${str}累计收入${totalIncome.toFixed(2)}万，利润率${sumProfitRate.toFixed(2)}%`;
                    }
                }
            });
        };
        // 获取流式数据
        const getStreamData = async (params, type, again = '') => {
            // 先清空
            if (type === 'part1') {
                part1StreamDescription.value = '';
                part1StreamContent.value = '';
                part1Loading.value = true;
            }
            if (type === 'part2') {
                part2StreamDescription.value = '';
                part2StreamContent.value = '';
                part2Loading.value = true;
            }
            if (type === 'part4') {
                part4StreamDescription.value = '';
                part4StreamContent.value = '';
                part4Loading.value = true;
            }
            if (type === 'part5') {
                part5StreamDescription.value = '';
                part5StreamContent.value = '';
                part5Loading.value = true;
            }
            const res = await streamCustomeOnePage(
                {
                    customer_name: detailData.value.customerName,
                    ...params
                },
                (chunk) => handleStreamChunk(chunk, type)
            );

            if (type === 'part1') {
                part1AbortFetch.value = res.abort;
            }
            if (type === 'part2') {
                part2AbortFetch.value = res.abort;
            }
            if (type === 'part4') {
                part4AbortFetch.value = res.abort;
            }
            if (type === 'part5') {
                part5AbortFetch.value = res.abort;
            }

            // 处理完成/错误
            res.promise
                .then(() => {
                    // 流处理完成
                    formatStreamData(type);
                    if (again === 'change') {
                        updatePart.value[type] = true;
                    }
                    return true;
                })
                .catch((e) => {
                    if (type === 'part1') {
                        part1AbortFetch.value = null;
                    }
                    if (type === 'part2') {
                        part2AbortFetch.value = null;
                    }
                    if (type === 'part4') {
                        part4AbortFetch.value = null;
                    }
                    if (type === 'part5') {
                        part5AbortFetch.value = null;
                    }
                    console.error('请求失败:', e);
                });
        };
        // 解析流式数据
        // eslint-disable-next-line complexity
        async function handleStreamChunk(chunk, flag) {
            const { type, content, elapsed_seconds } = chunk;

            const formatAiHtml = (str) => {
                if (!str) return '';
                return str.replace(/\\n|\n/g, '\r\n');
            };

            switch (type) {
            case 'think': {
                if (flag === 'part1') {
                    detailData.value.part1Runtime = elapsed_seconds;
                    part1StreamDescription.value += formatAiHtml(content);
                }
                if (flag === 'part2') {
                    detailData.value.part2Runtime = elapsed_seconds;
                    part2StreamDescription.value += formatAiHtml(content);
                }
                if (flag === 'part4') {
                    detailData.value.part4Runtime = elapsed_seconds;
                    part4StreamDescription.value += formatAiHtml(content);
                }
                if (flag === 'part5') {
                    detailData.value.part5Runtime = elapsed_seconds;
                    part5StreamDescription.value += formatAiHtml(content);
                }
                break;
            }
            case 'result': {
                if (flag === 'part1') {
                    part1StreamContent.value += formatAiHtml(content);
                }
                if (flag === 'part2') {
                    part2StreamContent.value += formatAiHtml(content);
                }
                if (flag === 'part4') {
                    part4StreamContent.value += formatAiHtml(content);
                }
                if (flag === 'part5') {
                    part5StreamContent.value += formatAiHtml(content);
                }
                break;
            }
            }
        };
        // 流处理完成
        const formatStreamData = (type) => {
            if (type === 'part1') {
                const { content, datasource } = formatDatasource(part1StreamContent.value);
                part1StreamContent.value = content;
                currentPageOriginPart.value[type] = _.cloneDeep(part1StreamContent.value);
                part1.value.ai.datasource = datasource;
                part1.value.ai.runtime = detailData.value.part1Runtime;
                part1Loading.value = false;
                part1AbortFetch.value = null;
            }
            if (type === 'part2') {
                const { content, datasource } = formatDatasource(part2StreamContent.value);
                part2StreamContent.value = content;
                currentPageOriginPart.value[type] = _.cloneDeep(part2StreamContent.value);
                part2.value.ai.datasource = datasource;
                part2.value.ai.runtime = detailData.value.part2Runtime;
                part2Loading.value = false;
                part2AbortFetch.value = null;
            }
            if (type === 'part4') {
                const { content, datasource } = formatDatasource(part4StreamContent.value);
                part4StreamContent.value = content;
                currentPageOriginPart.value[type] = _.cloneDeep(part4StreamContent.value);
                part4.value.ai.datasource = datasource;
                part4.value.ai.runtime = detailData.value.part4Runtime;
                part4Loading.value = false;
                part4AbortFetch.value = null;
            }
            if (type === 'part5') {
                const { content, datasource } = formatDatasource(part5StreamContent.value);
                part5StreamContent.value = content;
                currentPageOriginPart.value[type] = _.cloneDeep(part5StreamContent.value);
                part5.value.ai.datasource = datasource;
                part5.value.ai.runtime = detailData.value.part5Runtime;
                part5Loading.value = false;
                part5AbortFetch.value = null;
            }
        };
        // 关闭弹窗
        const handleClose = async () => {
            visible.value = false;
            part1StreamDescription.value = '';
            part1StreamContent.value = '';
            part1.value.ai.datasource = [];
            part1.value.ai.runtime = null;
            part1Loading.value = false;
            await part1AbortFetch.value?.();
            part2StreamDescription.value = '';
            part2StreamContent.value = '';
            part2.value.ai.datasource = [];
            part2.value.ai.runtime = null;
            part2Loading.value = false;
            part2.value.imgUrl = '';
            part2.value.fileList = [];
            await part2AbortFetch.value?.();
            part3.value.tableData1 = [];
            part3.value.tableData2 = [];
            part4StreamDescription.value = '';
            part4StreamContent.value = '';
            part4.value.ai.datasource = [];
            part4.value.ai.runtime = null;
            part4Loading.value = false;
            await part4AbortFetch.value?.();
            part5StreamDescription.value = '';
            part5StreamContent.value = '';
            part5.value.ai.datasource = [];
            part5.value.ai.runtime = null;
            part5Loading.value = false;
            await part5AbortFetch.value?.();
        };
        // 编辑标题
        const handleEditTitle = () => {
            if (saveStatus.value) return;
            MessageBox.prompt('', '编辑标题', {
                customClass: 'paper-dialog-edit-title',
                inputValue: detailData.value.pageName,
                showCancelButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                inputValidator: (val) => {
                    return !val ? '请输入标题' : true;
                }
            }).then(({ value }) => {
                detailData.value.pageName = value;
            });
        };
        // 监控数据变化
        const handleChange = (data, type) => {
            if (type === 'part1') {
                part1.value = { ...part1.value, ...data };
            }
            if (type === 'part2') {
                part2.value = { ...part2.value, ...data };
            }
            if (type === 'part4') {
                part4.value = { ...part4.value, ...data };
            }
            if (type === 'part5') {
                part5.value = { ...part5.value, ...data };
            }
        };
        const initUpdatePart = {
            part1: false,
            part2: false,
            part4: false,
            part5: false
        };
        const updatePart = ref(_.cloneDeep(initUpdatePart));
        const updatePart1 = ref(false);
        const updatePart2 = ref(false);
        const updatePart4 = ref(false);
        const updatePart5 = ref(false);
        // 更新文本
        const handleChangeContent = (data, type) => {
            if (type === 'part1') {
                part1StreamContent.value = data;
            }
            if (type === 'part2') {
                part2StreamContent.value = data;
                updatePart2.value = true;
            }
            if (type === 'part4') {
                part4StreamContent.value = data;
                updatePart4.value = true;
            }
            if (type === 'part5') {
                part5StreamContent.value = data;
                updatePart5.value = true;
            }
            updatePart.value[type] = true;
            currentPageOriginPart.value[type] = data;
        };
        // 预览
        const handlePreview = () => {
            filePreview({
                fileUrl: detailData.value.docUrl || detailData.value.pdfUrl,
                fileName: detailData.value.fileName
            });
        };
        // 存草稿/另存为/保存
        const handleSave = (type) => {
            const pageName = type === 'saveAs'
                ? `${detailData.value.customerName}一页纸${utils.formatDateTime(new Date(), 'YYYYMMDD')}${detailData.value.total}`
                : detailData.value.fileName || detailData.value.pageName;
            setupContext.refs.fileNameDialogRef.show(pageName, type);
        };
        // 一页纸附件名称弹窗回调
        const handleConfirm = async (file, type) => {
            const params = {
                ...detailData.value,
                ...file,
                part1: md.render(currentPageOriginPart.value.part1 || ''),
                part2: md.render(currentPageOriginPart.value.part2 || ''),
                part3: setupContext.refs.segmentPart3Ref.getPart3HTML(),
                part4: md.render(currentPageOriginPart.value.part4 || ''),
                part5: md.render(currentPageOriginPart.value.part5 || ''),
                imgUrl: part2.value.imgUrl
            };
            // 存草稿
            if (type === 'draft') {
                params.pageStatus = '0';
            }
            // 另存为
            if (type === 'saveAs') {
                params.pageStatus = '1';
                params.id = undefined;
                params.createTime = undefined;
                params.docUrl = undefined;
                params.pdfUrl = undefined;
                params.pageOwnerName = undefined;
                params.pageOwnerCode = undefined;
                params.pageName = `${detailData.value.customerName}一页纸${utils.formatDateTime(new Date(), 'YYYYMMDD')}${detailData.value.total}`;
            }
            // 保存
            if (type === 'save') {
                params.pageStatus = '1';
            }
            const { code, data } = await saveCustomeOnePage(params);
            if (+code === 0) {
                Message.success('保存成功');
                getDetailData(data.id);
                emit('updateList');
            }
        };

        return {
            visible,
            utils,
            detailData,
            part1,
            part2,
            part3,
            part4,
            part5,
            originalDataPart,
            diffHtmlPart,
            draftStatus,
            saveStatus,
            part1StreamDescription,
            part1StreamContent,
            part1Loading,
            part2StreamDescription,
            part2StreamContent,
            part2Loading,
            part4StreamDescription,
            part4StreamContent,
            part4Loading,
            part5StreamDescription,
            part5StreamContent,
            part5Loading,
            loading,
            currentPageOriginPart,
            originalData,
            show,
            handleClose,
            handleEditTitle,
            handleChange,
            handleChangeContent,
            getStreamData,
            handlePreview,
            handleSave,
            handleConfirm

        };
    }
};
</script>

<style lang="less" scoped>
h3 {
    background-color: #fff;
    border-radius: 10px;
    text-align: center;
    padding: 16px 0;
    margin: 0 0 10px 0;
}
.simple-diff {
  font-family: monospace;
  white-space: pre-wrap;
}

.diff-output {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #ddd;
  max-height: 400px;
  overflow-y: auto;
}

.added-line {
  background-color: #e6ffed;
  color: #24292e;
  display: block;
  padding: 2px 4px;
  margin: 1px 0;
  border-left: 3px solid #2ea44f;
}

.removed-line {
  background-color: #ffeef0;
  color: #24292e;
  display: block;
  padding: 2px 4px;
  margin: 1px 0;
  border-left: 3px solid #cb2431;
  text-decoration: line-through;
}
</style>
<style lang="less">
.paper-dialog {
    .el-dialog {
        height: 90vh;
        border-radius: 16px;
    }
    .el-dialog__header {
        font-size: 20px;
    }
    .el-dialog__body {
        background-color: #f5f6f7;
        overflow: auto;
        height: calc(100% - 135px);
    }
    .el-dialog__footer {
        text-align: center;
    }
    .el-button {
        border-radius: 8px;
        padding: 10px 32px;
        color: #000;
        &.is-disabled {
            color: #C0C4CC;
        }
        &.el-button--primary{
            color: #fff;
        }
    }
}
.paper-dialog-edit-title {
    width: 40vw;
    border-radius: 12px;
    .el-message-box__title {
        font-size: 16px;
        font-weight: 600;
    }
    .el-message-box__input {
        width: 100%;
    }
    .el-input__inner {
        background-color: #F2F3F5;
        color: #000;
        border-radius: 8px;
        height: 40px;
    }
    .el-button {
        border-radius: 8px;
        padding: 10px 32px;
    }
}
</style>
